var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSun({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 1.50366H12.75V5.25366H11.25V1.50366ZM5.10572 4.04882L4.04517 5.10938L6.67454 7.73875L7.7351 6.6782L5.10572 4.04882ZM12 9.00366C12.5933 9.00366 13.1734 9.17961 13.6667 9.50925C14.1601 9.8389 14.5446 10.3074 14.7716 10.8556C14.9987 11.4038 15.0581 12.007 14.9424 12.5889C14.8266 13.1709 14.5409 13.7054 14.1213 14.125C13.7018 14.5445 13.1672 14.8303 12.5853 14.946C12.0033 15.0618 11.4001 15.0024 10.852 14.7753C10.3038 14.5482 9.83524 14.1637 9.50559 13.6704C9.17595 13.177 9 12.597 9 12.0037C9.0009 11.2083 9.31725 10.4457 9.87967 9.88333C10.4421 9.32091 11.2046 9.00456 12 9.00366ZM12 7.50366C11.11 7.50366 10.24 7.76758 9.49994 8.26205C8.75991 8.75652 8.18314 9.45932 7.84254 10.2816C7.50195 11.1039 7.41283 12.0087 7.58647 12.8816C7.7601 13.7545 8.18868 14.5563 8.81802 15.1856C9.44736 15.815 10.2492 16.2436 11.1221 16.4172C11.995 16.5908 12.8998 16.5017 13.7221 16.1611C14.5443 15.8205 15.2471 15.2437 15.7416 14.5037C16.2361 13.7637 16.5 12.8937 16.5 12.0037C16.5 10.8102 16.0259 9.6656 15.182 8.82168C14.3381 7.97777 13.1935 7.50366 12 7.50366ZM1.5 11.2537H5.25V12.7537H1.5V11.2537ZM6.67454 16.2686L4.04517 18.8979L5.10572 19.9585L7.7351 17.3291L6.67454 16.2686ZM11.25 18.7537H12.75V22.5037H11.25V18.7537ZM17.3254 16.2685L16.2649 17.3291L18.8943 19.9585L19.9548 18.8979L17.3254 16.2685ZM18.75 11.2537H22.5V12.7537H18.75V11.2537ZM18.8943 4.04885L16.2649 6.67822L17.3255 7.73878L19.9549 5.1094L18.8943 4.04885Z",
    fill: "#DDDFDD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.df73b6c5.svg";
export { ForwardRef as ReactComponent };